import React from 'react';
import { Icon } from 'semantic-ui-react';

const activeAlarmsShape = new Map();

activeAlarmsShape.set('level', {
  header: {
    title: 'common.level',
  },
  cell: {
    renderFn: (level, values) => {
      const severity = [];
      for (let i = 0; i < level; i++) {
        severity.push(<Icon key={i} name="attention" color={values.color} />);
      }
      return <div>{severity}</div>;
    },
  },
});

activeAlarmsShape.set('color', {
  header: {
    title: 'common.color',
  },
  cell: {
    renderFn: (value, values, t) => t(`common.${value}`),
  },
});

activeAlarmsShape.set('machineName', {
  header: {
    title: 'common.machine',
  },
});

activeAlarmsShape.set('hall', {
  header: {
    title: 'common.hall',
  },
});

activeAlarmsShape.set('duration', {
  header: {
    title: 'common.duration',
  },
});

activeAlarmsShape.set('start', {
  header: {
    title: 'common.start',
  },
});

export default activeAlarmsShape;



// WEBPACK FOOTER //
// ./src/shapes/activeAlarmsShape.js